import Icons from './config/icons';
import './styles/main.scss'
import Intersect from "./directives/Intersect";
import {stripHtml} from "./helpers/html_helpers";
import ClickOutside from "./directives/ClickOutside";
import Resize from "./directives/Resize";
import Scroll from "./directives/Scroll";
import truncate from "./filters/truncate";
import toEuro from "./filters/toEuro";
import limit from "./filters/limit";
import uppercase from "./filters/uppercase";
import lowercase from "./filters/lowercase";
import Adapt from "./directives/Adapt";

const SpoferanUi = {
    install(Vue) {

        // Make sure that plugin can be installed only once
        if (this.installed) {
            return
        }
        this.installed = true;

        // Event bus to trigger global functionality on the components
        this.eventBus = new Vue();

        registerDirectives(Vue);
        registerFilters(Vue);
        registerPrototypes(Vue);
        registerGlobalNotificationSnackbar(Vue);
        registerGlobalPopupAlert(Vue);
    }
};

function registerDirectives(Vue) {
    Vue.directive('intersect', Intersect);
    Vue.directive('resize', Resize);
    Vue.directive('scroll', Scroll);
    Vue.directive('adapt', Adapt);
    Vue.directive('click-outside', ClickOutside);
}

function registerFilters(Vue) {
    Vue.filter('truncate', truncate);
    Vue.filter('euro', toEuro);
    Vue.filter('limit', limit);
    Vue.filter('uppercase', uppercase);
    Vue.filter('lowercase', lowercase);
}

function registerPrototypes(Vue) {
    Vue.prototype.$icons = Icons;
    Vue.prototype.$stripHtml = stripHtml;
    Vue.prototype.$downloadFile = (url) => {
        // flutter_inappwebview is deprecated in native app version 1.1.9+42
        if (window.flutter_inappwebview) {
            window.flutter_inappwebview.callHandler('download', url);
        } else if (window.native_download) {
            window.native_download.postMessage(url);
        } else {
            window.location.href = url;
        }
    };
}

/**
 * Enables the global trigger of a GlobalSnackbar component.
 *
 * @param Vue
 */
function registerGlobalNotificationSnackbar(Vue) {
    Vue.prototype.$notify = (type, message, title = null, duration = 4500) => {
        return new Promise((resolve) => {
            SpoferanUi.eventBus.$emit('snackbar_toggle', true, {
                color: type,
                message: message,
                title: title,
                duration: duration,
            }, {
                hide: () => {
                    resolve()
                }
            })
        })
    }
}

/**
 * Enables the global trigger of a GlobalPopupAlert component.
 *
 * @param Vue
 */
function registerGlobalPopupAlert(Vue) {
    Vue.prototype.$alert = (options) => {
        return new Promise((resolve) => {
            SpoferanUi.eventBus.$emit('alert_toggle', true, options, {
                confirm: (inputData) => {
                    resolve({confirmed: true, data: inputData})
                },
                cancel: () => {
                    resolve({confirmed: false})
                }
            })
        })
    };

    Vue.prototype.$confirm = (options) => {
        return Vue.prototype.$alert({...options, confirm: true, cancel: true});
    };
}

export default SpoferanUi
